import {useLogin} from "./dialogs/Login"
import PasswordList from "./components/PasswordList"
import Header from "./components/Header"
import PerfectScrollbar from "react-perfect-scrollbar"
import Search from "./components/Search"
import { useEffect, useState } from "react"
import PassApi from "./data/PassApi"
import Utils from "./libs/Utils"

const TIMEOUT = 60000
let timeout:any = null

export default function App(){
    const [scroll,setScroll] = useState<boolean>(false)
    const {isLoggedIn} = useLogin()

    const clear = () => {
        window.removeEventListener("focus", clear)
        Utils.clipboard("")
    }
    const onLogout = () => {
        console.log("onLogou", isLoggedIn)
        isLoggedIn && PassApi.i.logout()
        if (!document.hasFocus()) {
            window.addEventListener("focus", clear)
        }
    }
    useEffect(() => {
        timeout = setTimeout(onLogout, TIMEOUT)
        return () => { clearTimeout(timeout) }
    }, [])

    const onScroll = (e:any) => {
        setScroll(e.scrollTop>0)
        onAlive()
    }
    const onAlive = () => {
        clearTimeout(timeout)
        timeout = setTimeout(onLogout, TIMEOUT)
    }
    if (isLoggedIn) {
        return <>
            <Header/>
            <Search className={scroll ? "scroll" : ""}/>
            <PerfectScrollbar onScrollY={onScroll} onMouseMove={onAlive}>
                <PasswordList/>
            </PerfectScrollbar>
        </>
    }
    return <></>
}
